<template>
   <section class="video-fullscreen">
    <div class="video grayscale" data-overlay-dark="1">
        <div class="desgradado"></div>
      <video playsinline autoplay loop muted aria-label="Background Video">
        <source :src="videoMp4" type="video/mp4">
        <!-- Fallback for unsupported formats -->
        Your browser does not support HTML5 video.
      </video>
    
    </div>
    <div class="v-middle">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-12 mt-60">
            <h4 class="hZUCZe">{{ $t('We transform your ideas into great achievements') }}</h4>
            <h1 class="mb-10 text-h2-sans">{{ $t('Connect') }}<br/><span>{{ $t('with the Future') }}</span></h1>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="row">
    <div class="col-md-6">
        <div class="container">
            <hr>
            <h4 class="hZUCZe fs-25px">{{ $t('Contact us') }}</h4>
            <h1 class="mb-10 text-h2-sans">{{ $t("We'd love to talk!") }}</h1>
            <p class="text-p-sans mt-30">{{ $t('Your next great idea starts here. We are ready to listen to your needs and accompany you every step of the way. Complete the contact form or choose your preferred means to communicate with us. Together, we can create innovative solutions and take your projects to the next level.') }}</p>
            <h4 class="hZUCZe fs-25px mb-10">{{ $t("Write to us and let's make your ideas shine!") }}</h4>
            <div class="social-icon-list mt-30">
                <div class="social-icon">
                    <div class="icon">
                        <i class="bi bi-whatsapp"></i>
                    </div>
                    <span class="text-p-sans"><a href="https://wa.me/5541988025300?text=Hola%20quiero%20más%20información%20sobre%20sus%20servicios." target="_blank"> Whatsapp</a></span>
                </div>
                <div class="social-icon">
                    <div class="icon">
                        <i class="bi bi-telegram"></i>
                    </div>
                    <span class="text-p-sans"><a href="https://t.me/jlhsofttechnology" target="_blank"> Telegram</a></span>
                </div>
                <div class="social-icon">
                    <div class="icon">
                        <i class="bi bi-envelope"></i>
                    </div>
                    <span class="text-p-sans">info@jlhsoft.com</span>
                </div>
                <div class="social-icon">
                    <div class="icon">
                        <i class="bi bi-geo-alt-fill"></i>
                    </div>
                    <span class="text-p-sans">Curitiba, Paraná, Brasil</span>
                </div>
            </div>
            <div class="row mt-60">
                <div class="col-md-12">
                    <h4 class="hZUCZe">{{ $t('Hours of attention') }}</h4>
                    <div class="opening-hours">
                        <ul>
                            <li>
                                <div class="tit">{{ $t('Monday - Friday') }}</div>
                                <div class="dots"></div> <span>{{ $t('8:00 AM - 5:00 PM') }}</span>
                            </li>
                            <li>
                                <div class="tit">{{ $t('Saturday') }}</div>
                                <div class="dots"></div> <span>{{ $t('Closed') }}</span>
                            </li>
                            <li>
                                <div class="tit">{{ $t('Sunday - Holidays') }}</div>
                                <div class="dots"></div> <span>{{ $t('Closed') }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-6">
        <div class="container mt-30">
            <h4 class="hZUCZe fs-25px">{{ $t('Contact Form') }}</h4>
            
            <!-- Mensajes de estado -->
            <div v-if="formStatus.message" :class="['alert', formStatus.isError ? 'alert-danger' : 'alert-success']">
                {{ formStatus.message }}
            </div>

            <form @submit.prevent="handleSubmit" class="contact__form mt-30">
                <div class="row">
                    <div class="col-md-12 form-group">
                        <input 
                            v-model="formData.name"
                            name="name" 
                            type="text" 
                            :placeholder="$t('Name') + ' *'" 
                            :disabled="loading"
                            required>
                    </div>
                    <div class="col-md-6 form-group">
                        <input 
                            v-model="formData.email"
                            name="email" 
                            type="email" 
                            :placeholder="$t('Email Address') + ' *'" 
                            :disabled="loading"
                            required>
                    </div>
                    <div class="col-md-6 form-group">
                        <input 
                            v-model="formData.phone"
                            name="phone" 
                            type="tel" 
                            :placeholder="$t('Phone') + ' *'" 
                            :disabled="loading"
                            required>
                    </div>
                    <div class="col-md-12 form-group">
                        <input 
                            v-model="formData.subject"
                            name="subject" 
                            type="text" 
                            :placeholder="$t('Subject') + ' *'" 
                            :disabled="loading"
                            required>
                    </div>
                    <div class="col-md-12 form-group">
                        <textarea 
                            v-model="formData.message"
                            name="message" 
                            id="message" 
                            cols="30" 
                            rows="4" 
                            :placeholder="$t('How can we help you? Feel free to get in touch!') + ' *'" 
                            :disabled="loading"
                            required></textarea>
                    </div>
                    <div class="col-md-12">
                        <button type="submit" :disabled="loading">
                            {{ loading ? $t('Sending...') : $t('Send') }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
  </div>
 
</template>

<script>
import videoMp4 from '@/assets/videos/video2.mp4'
import axios from 'axios';

export default {
    name: 'ContactPage',
    data() {
        return {
            videoMp4: videoMp4,
            loading: false,
            formStatus: {
                message: '',
                isError: false
            },
            formData: {
                name: '',
                email: '',
                phone: '',
                subject: '',
                message: ''
            }
        }
    },
    methods: {
        async handleSubmit() {
            this.loading = true
            this.formStatus.message = ''
            
            try {
                // Aquí deberías implementar tu lógica de envío
                // Por ejemplo, usando axios para enviar a tu API:
                await axios.post('https://mailerweb.jlhsoft.com/api/contact', this.formData)
                
                // Simulando un delay para el ejemplo
                await new Promise(resolve => setTimeout(resolve, 1000))
                
                this.formStatus.message = this.$t('Thank you! We will contact you soon.')
                this.formStatus.isError = false
                
                // Limpiar el formulario
                this.formData = {
                    name: '',
                    email: '',
                    phone: '',
                    subject: '',
                    message: ''
                }
            } catch (error) {
                this.formStatus.message = this.$t('There was an error sending your message. Please try again.')
                this.formStatus.isError = true
            } finally {
                this.loading = false
            }
        }
    }
}
</script>

<style scoped>
.video-fullscreen {
    width: 100%;
    overflow: hidden;
  }
  .video-fullscreen .video.grayscale {
      -webkit-filter: grayscale(100%);
      filter: grayscale(100%);
  }
  .video-fullscreen .video {
      height: 100vh;
  }
  .video-fullscreen video {
    width: 100vw;
    min-width: 100%;
    height: 100vh;
    object-position: top;
    -o-object-fit: cover;
    object-fit: cover;
  }

  .v-middle {
    position: absolute;
    width: 100%;
    top: 50%;
    left: 0;
    -webkit-transform: translate(0%, -50%);
    transform: translate(0%, -50%);
    z-index: 9;
}
.social-icon-list{
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.social-icon{
    display: flex;
    align-items: center;
    gap: 10px;
}
.icon{
    width: 50px;
    height: 50px;
    background-color: #fff;
    color: #000;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease;	
}
/* opening-hours list */
.opening-hours ul {
    margin: 0;
    padding: 0;
    margin-bottom: 30px;
    width: 320px;
}
.opening-hours ul li .tit,
.opening-hours ul li .dots,
.opening-hours ul li span {
    display: table-cell;
    white-space: nowrap;
}
.opening-hours ul li {
    margin-bottom: 15px;
    font-size: 16px;
}
.opening-hours ul li:last-of-type {
    margin-bottom: 0;
}
.opening-hours ul li span {
    white-space: nowrap;
    padding-left: 10px;
    color: #ccc;
}
.opening-hours ul li .tit {
    padding-right: 10px;
    color: #ccc;
}
.opening-hours ul li .dots {
    height: 4px;
    width: 100%;
    border-bottom: 2px solid rgba(220, 39, 81,0.2);
    position: relative;
    top: -7px;
}
/* End Opening Hours */
input[type="password"],
input[type="email"],
input[type="text"],
input[type="tel"],
input[type="file"],
textarea {
    max-width: 100%;
    margin-bottom: 15px;
    padding: 15px 20px;
    height: auto;
    background-color: transparent;
    -webkit-box-shadow: none;
    box-shadow: none;
    display: block;
    width: 100%;
    line-height: 1.5em;
    font-family: 'Hind', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
    background-image: none;
    border: 1px solid hsla(0, 0%, 100%, .1);
    border-radius: 30px;
}
input:focus,
textarea:focus {
    border: 2px solid #fff;
}
/* submit and alert success  */
input[type="submit"],
input[type="reset"],
input[type="button"],
button {
     font-family: 'Poppins', sans-serif;
    font-weight: 400;
    text-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    line-height: 1.75em;
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 80px;
    background-color: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    -webkit-transition: color 400ms ease, background-color 400ms ease;
    transition: color 0.2s ease-in-out, background-color 400ms ease-in-out;
    color: #fff;
    line-height: 20px;
    text-align: center;
    padding: 12px 100px;
    height: auto;
    position: relative;
    overflow: hidden;
    cursor: pointer;
}
input[type="submit"]:hover,
input[type="reset"]:hover,
input[type="button"]:hover,
button:hover {
    border: none;
    background: #fff;
    color: #1b1b1b;
}
button.mfp-close:hover,
button.mfp-arrow:hover {
    background: transparent;
}
.alert-success {
    background: transparent;
    color: #ccc;
    border: 2px solid #dc2751;
    border-radius: 0px;
}

/* Agregar estilos para los estados del formulario */
.alert {
    padding: 15px;
    margin-bottom: 20px;
    border-radius: 30px;
    text-align: center;
}

.alert-success {
    background-color: rgba(40, 167, 69, 0.1);
    border: 2px solid #28a745;
    color: #28a745;
}

.alert-danger {
    background-color: rgba(220, 39, 81, 0.1);
    border: 2px solid #dc2751;
    color: #dc2751;
}

button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

input:disabled,
textarea:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}
</style>